import { styled } from '@material-ui/core'
import { NearMe } from '@material-ui/icons'

export default styled(NearMe)(() => ({ transform: 'scaleX(-1)' }))
